import { render } from "./AppointmentNotes.vue?vue&type=template&id=7ae0e2c7&scoped=true"
import script from "./AppointmentNotes.vue?vue&type=script&lang=js"
export * from "./AppointmentNotes.vue?vue&type=script&lang=js"

import "./AppointmentNotes.vue?vue&type=style&index=0&id=7ae0e2c7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae0e2c7"]])

export default __exports__